import React, { useState, useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import styles from "./index.module.scss";

function Tabs({ children }) {
  // filtering out all null values
  children = children.filter(n => n);

  const history = useHistory();
  const [activeTab, setActiveTab] = useState(children[0].props.label);

  const handleActiveTab = useCallback(label => setActiveTab(label), []);

  useEffect(() => {
    let defaultTab = children[0].props.label;
    children.map(child => {
      if (child.props.defaultTab) {
        defaultTab = child.props.label;
      }
    });
    setActiveTab(defaultTab);
  }, []);

  const tabs = children.map(child => (
    <li
      onClick={e => {
        e.preventDefault();
        if (child.props.linkTo) {
          history.push(child.props.linkTo);
        }
        handleActiveTab(child.props.label);
      }}
      className={child.props.label === activeTab ? styles.active : styles.tab}
      key={child.props.label}
    >
      {child.props.tabName}
    </li>
  ));

  const tabContent = children.filter(child => child.props.label === activeTab);
  return (
    <div>
      <div className={styles.tabWrapper}>
        <ul className={styles.tabStyle}>{tabs}</ul>
      </div>
      <div>{tabContent}</div>
    </div>
  );
}

function Tab(props) {
  return <>{props.children}</>;
}

export { Tabs, Tab };
